import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BackgroundVideo } from "./components/BackgroundVideo";
import { WarmHeader } from "./components/WarmHeader";
import { HeroSection } from "./sections/HeroSection";
import { BiografiaSection } from "./sections/BiografiaSection";
import { ContactSection } from "./sections/ContactSection";
import { useI18n } from "./config/i18n";
import { useSectionRefs } from "./hooks/useSectionRefs";
import { useActiveSection } from "./hooks/useActiveSection";
import { useScrollProgress } from "./hooks/useScrollProgress";
import { ReleasesSection } from "./sections/ReleasesSection";
import { EventsSection } from "./sections/EventsSection";
export default function App() {
    const { t } = useI18n();
    const { sectionRefs, setSectionRef } = useSectionRefs();
    const order = ["hero", "biografia", "events", "releases", "contact"];
    const activeSection = useActiveSection(order, sectionRefs);
    const scrollProgress = useScrollProgress();
    // Optional: use scrollProgress for a progress bar if you want
    // console.log(scrollProgress);
    return (_jsxs(_Fragment, { children: [_jsx(WarmHeader, { activeSection: activeSection, t: t }), _jsx(BackgroundVideo, { src: t.media.heroBackgroundVideo }), _jsx("div", { ref: setSectionRef("hero"), children: _jsx(HeroSection, { t: t }) }), _jsx("div", { ref: setSectionRef("biografia"), children: _jsx(BiografiaSection, { t: t }) }), _jsx("div", { ref: setSectionRef("events"), children: _jsx(EventsSection, { t: t }) }), _jsx("div", { ref: setSectionRef("releases"), children: _jsx(ReleasesSection, { t: t }) }), _jsx("div", { ref: setSectionRef("contact"), children: _jsx(ContactSection, { t: t }) })] }));
}
